import * as React from 'react';
import { IReactErrorLogProps, IReactErrorLogState } from './types';

export class ReactErrorLog extends React.Component<IReactErrorLogProps, IReactErrorLogState> {
  public state = {
    hasError: false,
  };

  public static defaultProps = {
    fallback: null,
  };

  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  public componentDidMount() {
    const { onSuccess } = this.props;

    if (onSuccess) {
      onSuccess();
    }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { onError } = this.props;

    if (onError) {
      onError(error, errorInfo);
    }
  }

  public render() {
    const { children, fallback } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return fallback;
    }

    return children;
  }
}
